import React, { Component } from 'react'
import { Form, Label, Input, FormGroup, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { SERVER_URL } from '../constants/variables';
import ayekartLogo from "../assets/images/ayekartLogo.png";
import LoadingScreen from './LoadingScreen';
import './LoginComponent.css';

export default class LoginComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      isLoading: false
    }
    this.handleInputChange = this.handleInputChange.bind(this);

  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onLoginSubmit = () => {
    var email = this.state.email;
    var password = this.state.password;
    if(email === "" || password === "") {
      toast("Enter all fields");
    } else {
      toast.loading("Checking credentials", {
        duration: 2000
      });
      var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          "username": email,
          "password": password
        });

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };

        fetch(SERVER_URL + "/users/login", requestOptions)
          .then(response => response.json())
          .then(result => {
            if(result.success) {
              localStorage.setItem("user", JSON.stringify(result));
              this.setState({ isLoading: true });
              // Show loading screen for 2 seconds before redirecting
              setTimeout(() => {
                window.location = "/home";
              }, 2000);
            } else {
              toast.error("Invalid credentials");
            }
          })
          .catch(() => {
            toast.error("Login failed. Please try again.");
          });
    }
  }

  componentDidMount() {
    var user = localStorage.getItem("user");
    if(user) {
        toast("Already logged in");
        window.location = "/home";
    }
  }
  render() {
    if (this.state.isLoading) {
      return <LoadingScreen message="Getting insights for you..." />;
    }

    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-logo-container">
            <img src={ayekartLogo} alt="Ayekart Logo" />
          </div>
          <h2 className="login-title">Welcome Back</h2>
          <Form onSubmit={(e) => { e.preventDefault(); this.onLoginSubmit(); }}>
            <FormGroup className="login-form-group">
              <Label for="email" className="login-label">
                Email
              </Label>
              <Input
                id="email"
                name="email"
                placeholder="Enter your email"
                type="email"
                className="login-input"
                value={this.state.email}
                onChange={this.handleInputChange}
              />
            </FormGroup>
            <FormGroup className="login-form-group">
              <Label for="password" className="login-label">
                Password
              </Label>
              <Input
                id="password"
                name="password"
                placeholder="Enter your password"
                type="password"
                className="login-input"
                value={this.state.password}
                onChange={this.handleInputChange}
              />
            </FormGroup>
            <Button 
              type="submit" 
              className="login-button"
              onClick={(e) => { e.preventDefault(); this.onLoginSubmit(); }}
            >
              Sign In
            </Button>
            <div className="login-forgot-link">
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}
